import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { graphql, StaticQuery } from 'gatsby';
import { ContactFormFullwidth, CaseStudyBanner } from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  Process,
  WhatWeUse,
  HowWeWork,
  Certificates,
  MeetTeam,
  OtherServices,
} from './subcomponents';
import './MachineLearning.scss';

class MachineLearning extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query {
            npoLogo: file(relativePath: { eq: "logos/npo-white.png" }) {
              childImageSharp {
                fluid(maxWidth: 85) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            eyeBannerImage: file(
              relativePath: {
                eq: "machine-learning/human-eye-violet-tone.png"
              }
            ) {
              childImageSharp {
                fluid(maxWidth: 800) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div className={'single-page single-page--hero machine-learning'}>
            <Banner />
            <Process />
            <WhatWeUse />
            <CaseStudyBanner
              link={'/blog/machine-learning-content-moderation/'}
              color={'red'}
              textColor={'white'}
              image={data.eyeBannerImage.childImageSharp.fluid}
              logo={data.npoLogo.childImageSharp.fluid}
              client={'NPO'}
              title={
                'Speeding up e-commerce content moderation with Machine Learning based on Amazon Web Services'
              }
              tags={['symfony', 'microservices', 'saas']}
            />
            <LazyLoad offset={200}>
              <HowWeWork />
            </LazyLoad>
            <Certificates />
            <MeetTeam allArticles={allArticles} />
            <ContactFormFullwidth
              name={'machine-learning-contact-form'}
              pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x8t'}
            />
            <OtherServices />
          </div>
        )}
      />
    );
  }
}

export default MachineLearning;
